var initialize = require('./tripletrax.initialize.js');
var utils = require('./tripletrax.utils.js');

function ajaxCall(url, type, data, show_breadcrumb, done) {
    ajaxCallExtended(url, type, data, show_breadcrumb, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, null, done);
}

function ajaxCallExtended(url, type, data, show_breadcrumb, processData, contentType, headerKeys, fail, done) {

    var container = $('#content');

    if (show_breadcrumb) {
        $('nav li.active').removeClass("active");
        // match the url and add the active class
        $('nav li:has(a[href="' + url + '"])').addClass("active");
        var title = ($('nav a[href="' + url + '"]').attr('title'));

        // change page title from global var
        document.title = (title || document.title);
    }

    var promise = $.ajax({
        url: url,
        type: type,
        data: data,
        async: true,
        processData: processData,
        contentType: contentType,
        beforeSend: function (xhr) {
            if (headerKeys !== null) {
                xhr.setRequestHeader(headerKeys[0], headerKeys[1]);
            } else {
                xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
            }
            if (show_breadcrumb) {
                container.empty();
                container.html('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

                if (container[0] == $("#content")[0]) {
                    drawBreadCrumb(Lang.get('tripletrax.admin_title'));

                    // scroll up
                    $("html, body").animate({
                        scrollTop: 0
                    }, "fast");

                } else {
                    container.animate({
                        scrollTop: 0
                    }, "fast");
                }
            }
        }
    }).done(function (data) {
        if (/^FAILS/.test(data) || /^Error/.test(data)) {
            $.bigBox({
                title : trans('tripletrax.error'),
                content: trans('tripletrax.error_message'),
                color: "#CA4862",
                sound: $.sound_off,
                icon: "fad fa-exclamation-triangle shake animated"
            });

            return;
        }

        done(data);
    }).fail(function (error) {
        if (fail === null) {
            if (error.status == "401") {
                location.reload();
            } else if (error.status == "409") {
                // IDAT Fehler Code
            } else if (error.status == "503" || error.status == "504") {
                utils.setHtmlData($("html"), error.responseText);
            } else {
                utils.setHtmlData($("#content"), error.responseText);
            }
        } else {
            fail(error);
        }
    });

    return promise;
}

function ajaxCallDeferred(url, type, data, show_breadcrumb) {

    return ajaxCallDeferredExtended(url, type, data, show_breadcrumb, true, 'application/x-www-form-urlencoded; charset=UTF-8', null, true);
}

function ajaxCallDeferredExtended(url, type, data, show_breadcrumb, processData, contentType, headerKeys, addCSFRToken) {

    var container = $('#content');

    if (show_breadcrumb) {
        $('nav li.active').removeClass("active");
        // match the url and add the active class
        $('nav li:has(a[href="' + url + '"])').addClass("active");
        var title = ($('nav a[href="' + url + '"]').attr('title'));

        // change page title from global var
        document.title = (title || document.title);
    }

    var promise = $.ajax({
        url: url,
        type: type,
        data: data,
        async: true,
        processData: processData,
        contentType: contentType,
        beforeSend: function (xhr) {
            if (headerKeys !== null) {
                xhr.setRequestHeader(headerKeys[0], headerKeys[1]);
            }
            if (addCSFRToken) {
                xhr.setRequestHeader('X-CSRF-TOKEN', $('meta[name="csrf-token"]').attr('content'));
            }
            if (show_breadcrumb) {
                container.empty();
                container.html('<h1><i class="fad fa-cog fa-spin"></i> ' + Lang.get('tripletrax.loading') + '...</h1>');

                if (container[0] == $("#content")[0]) {
                    drawBreadCrumb(Lang.get('tripletrax.admin_title'));

                    // scroll up
                    $("html, body").animate({
                        scrollTop: 0
                    }, "fast");

                } else {
                    container.animate({
                        scrollTop: 0
                    }, "fast");
                }
            }
        }
    }).fail(function(error) {

        console.error(error);
        if (error.status == "401") {
            location.reload();
        } else if (error.status == "409") {
            // IDAT Fehler Code
        } else if (error.status == "503" || error.status == "504") {
            utils.setHtmlData($("html"), error.responseText);
        } else {
            utils.setHtmlData($("#content"), error.responseText);
        }
    });

    return promise;
}

function ajaxSucceeded(data) {

    if (/^FAILS/.test(data)) {
        $.bigBox({
            title : trans('tripletrax.error'),
            content: trans('tripletrax.error_message'),
            color: "#CA4862",
            sound: $.sound_off,
            icon: "fad fa-exclamation-triangle shake animated"
        });

        return false;
    }

    return true;
}

function drawBreadCrumb(homeText) {
    var nav_elems = $('nav li.active > a'),
         count = nav_elems.length,
         bread_crumb = $('#ribbon ol.breadcrumb');

    bread_crumb.empty();
    bread_crumb.append($("<li>" + homeText + "</li>"));
    nav_elems.each(function () {
        bread_crumb.append($("<li></li>").html($.trim($(this).clone().children(".badge").remove().end().text())));
        // update title when breadcrumb is finished...
        if (!--count) {
            document.title = $("<li></li>").html($.trim($(this).clone().children(".badge").remove().end().text())).text();
        }
    });

    // clear dom reference
    nav_elems = null;
}

module.exports.ajaxCall = ajaxCall;
module.exports.ajaxCallExtended = ajaxCallExtended;
module.exports.ajaxCallDeferred = ajaxCallDeferred;
module.exports.ajaxCallDeferredExtended = ajaxCallDeferredExtended;
module.exports.ajaxSucceeded = ajaxSucceeded;
module.exports.initializeElements = initialize.initializeElements;
